import * as turf from "@turf/turf";
import {CoordinatesType, PositionType} from "../types/shape";
import {getCoordinatesFromGeoJSON} from "./geoJSONHelper";

export const sortCoordinatesLatDESC = (
  coords: CoordinatesType
): CoordinatesType => {
  return sliceAwayLastDuplicatedCoordinates(coords)
    .sort((a, b) => {
      let isLowerThan = 1;
      if (getLat(a) === getLat(b)) {
        isLowerThan = 0;
      } else if (getLat(a) > getLat(b)) {
        isLowerThan = -1;
      }
      return isLowerThan;
    })
};

export const sortCoordinatesLatASC = (
  coords: CoordinatesType
): CoordinatesType => {
  return sliceAwayLastDuplicatedCoordinates(coords)
    .sort((a, b) => {
      let isGreaterThan = 1;
      if (getLat(a) === getLat(b)) {
        isGreaterThan = 0;
      } else if (getLat(a) < getLat(b)) {
        isGreaterThan = -1;
      }
      return isGreaterThan;
    })
};

export const sortCoordinatesLongDESC = (
  coords: CoordinatesType
): CoordinatesType => {
  return sliceAwayLastDuplicatedCoordinates(coords)
    .sort((a, b) => {
      let isLowerThan = 1;
      if (getLong(a) === getLong(b)) {
        isLowerThan = 0;
      } else if (getLong(a) > getLong(b)) {
        isLowerThan = -1;
      }
      return isLowerThan;
    })
};

export const sortCoordinatesLongASC = (
  coords: CoordinatesType
): CoordinatesType => {
  return sliceAwayLastDuplicatedCoordinates(coords)
    .sort((a, b) => {
      let isGreaterThan = 1;
      if (getLong(a) === getLong(b)) {
        isGreaterThan = 0;
      } else if (getLong(a) < getLong(b)) {
        isGreaterThan = -1;
      }
      return isGreaterThan;
    })
};

export const getVertexCountFromCoordinates = (
  coords: CoordinatesType
): number => {
  return getVertexFromCoordinates(coords).length;
};

export const isAQuadrilateralFromCoordinates = (
  coords: CoordinatesType
): boolean => {
  return getVertexFromCoordinates(coords).length === 4;
};

export const getVertexFromCoordinates = (
  coords: CoordinatesType
): CoordinatesType => {
  return sliceAwayLastDuplicatedCoordinates(coords);
};

export const sliceAwayLastDuplicatedCoordinates = (coords: CoordinatesType): CoordinatesType => {
  return samePositions(coords[0], coords[coords.length - 1])
    ? coords.slice(0, coords.length - 1) // removed the last duplicated coords
    : coords.slice(0)
}

export const samePositions = (p1: PositionType, p2: PositionType): boolean => {
  return getLong(p1) === getLong(p2) && getLat(p1) === getLat(p2);
}

export const getConvexHullCoordinatesFrom = (coordinates: CoordinatesType) => {
  const polygon = turf.polygon([coordinates]);
  const turfConvexPolygon = turf.convex(polygon);
  return getCoordinatesFromGeoJSON(turfConvexPolygon)
}

export const getLong = (position: PositionType) => position[0];

export const getLat = (position: PositionType) => position[1];

export const areValidCoordinates = (coords: unknown): coords is CoordinatesType => {
  return coords && typeof coords === 'object' && (coords as any).length &&
    (coords as unknown[]).every(p => p && typeof p === 'object' && (p as unknown[]).length === 2 && typeof p[0] === 'number' && typeof p[1] === 'number') &&
    !areThereAnyDuplicatedPositions(coords as CoordinatesType)
}

const areThereAnyDuplicatedPositions = (coordinates: CoordinatesType): boolean => {
  const coords = sliceAwayLastDuplicatedCoordinates(coordinates);
  return coords.some((p1, index1) => coords.some((p2, index2) => {
    return index1 !== index2 && samePositions(p1, p2)
  }))
}

export const convertDegreesMinutesSecondsToDecimal = (degrees: number, minutes: number, seconds: number): number => {
    return degrees + (minutes / 60) + (seconds / 3600)
}
